import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { ErrorText, Heading, SecondaryText } from 'components/core/Typography';
import type { SectionName } from '../AutomatedCheckModal';
import Spacer from 'sharedComponents/core/Spacers/Spacer';
import UploadFiles, { FileUpload } from '../UploadFiles';
import Button from 'components/Button/Button';

const useStyles = createUseStyles((theme: Theme) => ({
  divider: {
    width: '100%',
    height: 1,
    background: '#a4a4a442',
    margin: '30px 0px'
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    justifyContent: 'flex-end'
  }
}));

type Props = {
  sectionName: SectionName;
  delegateUUID: string;
  verificationID?: string;
  files: FileUpload[];
  onUpdateFiles: (files: FileUpload[]) => void;
  onNext: () => void;
  onPrev: () => void;
};

function Reference({
  sectionName,
  delegateUUID,
  verificationID,
  files,
  onUpdateFiles,
  onNext,
  onPrev
}: Props) {
  const classes = useStyles();
  return (
    <>
      <Heading>Reference upload</Heading>
      <SecondaryText>
        Upload 5 year activity history reference documents, including any HMRC
        screenshots if used.
      </SecondaryText>
      <>
        <Spacer vertical spacing={2} />
        <UploadFiles
          delegateUUID={delegateUUID}
          automatedVerificationID={verificationID}
          fileStage={sectionName}
          files={files}
          onUpdateFiles={onUpdateFiles}
          title="Drag or click to upload"
          description={
            <>
              Supported files: .PDF, .JPG, .PNG
              <br />
            </>
          }
        />
      </>

      <div className={classes.divider} />
      {/* <ErrorText style={{ textAlign: 'right' }}>{errorText}</ErrorText> */}
      <Spacer vertical spacing={1} />
      <div className={classes.buttons}>
        <Button
          archetype="flat"
          onClick={() => {
            onPrev();
          }}
        >
          Back
        </Button>
        <Button
          archetype="flatPrimary"
          disabled={files.length === 0}
          onClick={() => {
            onNext();
          }}
        >
          Next
        </Button>
      </div>
    </>
  );
}

export default Reference;
